import { staticState } from '@wellesley/host-remote/common/staticState'
import { logger } from '../logger'

export const getServerName = () => {
  try {
    const { baseUrl } = staticState.get()
    const staticHostname = baseUrl && new URL(baseUrl).hostname

    return staticHostname || window.location.hostname
  } catch (e) {
    logger.warn('getServerName: Error getting server name', e)
    return ''
  }
}
